
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import RadioButton from '@/components/radio-button.vue';
import Message from '@/components/message.vue';
import dialog from '@/components/dialog.vue';
import uploadImg from "@/components/upload-img.vue"
import {
	activityKoiFishorderList,
	activityKoiFishPrizeName,
	activityKoiFishMemberKoiFishWinnerList,
	activityKoiFishRewardSendImport
} from "@/api/live";
import axios from 'axios';

@Component({
	name: '',
	components: {
		PageFooter,
		PickerDate,
		RadioButton,
		uploadImg,
		'slz-message': Message,
		'slz-dialog': dialog,
	}
})

export default class ProductList extends Vue {

	private radioType = 1
	private radioList = [
		{ value: 1, label: '活动订单数据' },
		{ value: 2, label: '开奖名单' },
	]

	private prizeNames = [];
	private states: any = [
		{ value: null, label: '全部' },
		{ value: 0, label: '已使用' },
		{ value: 1, label: '未使用' },
		{ value: 2, label: '已失效' },
	];

	private dataTab: any = {
		keywords: '',
		list: [],
		pageNo: 1,
		pageSize: 10,
		total: 0,
		loading: false
	}

	private memberTab: any = {
		prizeId: undefined,
		state: null,
		keywords: '',
		list: [],
		pageNo: 1,
		pageSize: 10,
		total: 0,
		loading: false
	}

	private importShow = false
    private filePath:string[] = []
    private fileName = ''
    private importMsg:any = {
      schedule:0,
      filePath:[],
      fileName:'',
      FailCount:0,
      RecordId:0,
    }
    private sucShow = false

	private type = +this.$route.query.type

	private mounted() {
		this.gettablelist()
		this.getPrizeNames();

	}

	private async getPrizeNames() {
		try {
			let res: any = await activityKoiFishPrizeName({
				ActivityKoiFishId: this.$route.query.Id
			})
			if (res.IsSuccess) {
				this.prizeNames = res.Result.map(item => {
					return {
						value: item.ActivityKoiFishPrizeId,
						label: item.PrizeName
					}
				});
			}
		} finally {
		}
	}

	private handleChange(e) {

		if (e == 1) {
			this.dataTab.pageNo = 1;
			this.gettablelist()
		} else {
			this.memberTab.pageNo = 1;
			this.getMemberlist()
		}
	}

	private exportfile() {
		let url = location.origin + '/pc/activityKoiFish/orderList'
		url += '?ActivityKoiFishId=' + this.$route.query.Id
		url += '&Keywords=' + encodeURIComponent(this.dataTab.keywords)
		window.open(url)
	}
	private async gettablelist() {
		try {
			this.dataTab.loading = true
			let res: any = await activityKoiFishorderList({
				Keywords: this.dataTab.keywords,
				ActivityKoiFishId: this.$route.query.Id,
				Skip: (this.dataTab.pageNo - 1) * this.dataTab.pageSize,
				Take: this.dataTab.pageSize
			})
			if (res.IsSuccess) {
				this.dataTab.list = res.Result.Results
				this.dataTab.total = res.Result.Total
			}
		} finally {
			this.dataTab.loading = false
		}
	}
	private changePage(e) {
		this.dataTab.pageNo = e
		this.gettablelist()
	}
	private doSearch() {
		this.changePage(1)
	}
	private clearSearch() {
		this.dataTab.keywords = ''
		this.changePage(1)
	}


	private exportMember(){
		let url = location.origin + '/pc/activityKoiFish/activityKoiFishMemberKoiFishWinnerList'
		url += '?ActivityKoiFishId=' + this.$route.query.Id
		url += '&Keywords=' + encodeURIComponent(this.memberTab.keywords);
		url += '&State=' + (this.memberTab.state || '');
		url += '&ActivityKoiFishPrizeId=' + (this.memberTab.prizeId || '');
		window.open(url)
	}
	private memberTabSearch() {
		this.memberTabChangePage(1);
	}
	private memberTabChangePage(e) {
		this.memberTab.pageNo = e
		this.getMemberlist()
	}
	private memberTabClearSearch() {
		this.memberTab.keywords = ''
		this.memberTab.prizeId = undefined
		this.memberTab.state = null
		this.memberTabChangePage(1)
	}
	private async getMemberlist() {
		try {
			this.memberTab.loading = true
			let res: any = await activityKoiFishMemberKoiFishWinnerList({
				Keywords: this.memberTab.keywords,
				ActivityKoiFishPrizeId: this.memberTab.prizeId,
				State: this.memberTab.state,
				ActivityKoiFishId: this.$route.query.Id,
				Skip: (this.memberTab.pageNo - 1) * this.memberTab.pageSize,
				Take: this.memberTab.pageSize
			})
			if (res.IsSuccess) {
				this.memberTab.list = res.Result.Results
				this.memberTab.total = res.Result.Total
			}
		} finally {
			this.memberTab.loading = false
		}
	}

	private importResult() {
		// console.log(this.importMsg.RecordId)
		this.getresult(this.importMsg.RecordId, true)
	}
	private async confirmImport() {
		if (!this.importMsg.filePath || !this.importMsg.filePath.length) {
			this.$message.error('请上传文件')
			return
		}
		try {
			this.sucShow = true
			this.importMsg.schedule = 1
			let res: any = await activityKoiFishRewardSendImport({
				ActivityWheelSurfId: this.$route.query.Id,
				ExcelFilePath: this.importMsg.filePath[0],
				ExcelFileName: this.importMsg.fileName
			})
			if (res.IsSuccess) {
				this.importMsg.RecordId = res.Result.RecordId
				this.getresult(res.Result.RecordId, false)
			}
		} catch {
			this.sucShow = false
			this.importMsg.schedule = 1
		}
		finally {
			// this.importMsg.schedule = 2
		}
	}
	private async getresult(RecordId, IsExport) {
		try {
			let res: any = await axios.get('/pc/activityKoiFish/activityKoiFishRewardSendImportResultExport' + `?RecordId=${RecordId}&IsExport=${IsExport}`, {
				responseType: IsExport ? 'blob' : undefined,
			})
			if (!IsExport) {
				if (res.data.IsSuccess) {
					this.importMsg = {
						...res.data.Result,
						schedule: 1,
						RecordId: RecordId
					}
					if (!res.data.Result.IsDealFinish) {
						setTimeout(() => {
							this.getresult(RecordId, false)
						}, 500)
					} else {
						this.importMsg = {
							...res.data.Result,
							schedule: 2,
							RecordId: RecordId
						}
						this.sucShow = true
					}
				} else {
					this.$message.error(res.data.Message)
					this.sucShow = false
				}
			} else {
				let blob = new Blob([res.data], { type: "application/octet-stream; charset=utf-8" })
				let a = document.createElement('a')
				a.style.display = 'none'
				a.download = `导入中奖物流反馈表格.xlsx`
				a.href = URL.createObjectURL(blob)
				a.click()
				a.remove()
			}
		} finally {
			//
		}
	}
	private importCancel() {
		this.importShow = false
		this.sucShow = false
		this.importMsg = {
			schedule: 0,
			filePath: [],
			fileName: '',
			failCount: 0
		}
	}
	private uploadSuc(file, name) {
		this.importMsg.filePath = file
		this.importMsg.fileName = name
	}
}
